import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import HeadingLarge from "../../Typography/titles/HeadingLarge";
import HeadingMedium from "../../Typography/titles/HeadingMedium";
import HeadingSmall from "../../Typography/titles/HeadingSmall";
import styles from '../Carousel.module.scss';
import CarouselText from './CarouselText';
const HeadingSelector = (_a) => {
    var { titleSize, children } = _a, props = __rest(_a, ["titleSize", "children"]);
    switch (titleSize) {
        case 'medium':
            return React.createElement(HeadingMedium, Object.assign({}, props), children);
        case 'large':
            return React.createElement(HeadingLarge, Object.assign({}, props), children);
        default:
            return React.createElement(HeadingSmall, Object.assign({}, props), children);
    }
};
const CarouselHeading = ({ title, titleClassName, hasPadding, arrowsToTopRight, disablePrevArrow, disableNextArrow, labels, carouselRef, isTitleCenterAligned, titleSize, HeadingTag, className, }) => {
    const headingProps = {
        Tag: HeadingTag || 'h3',
        className: cn(titleClassName, styles.title, hasPadding && styles.paddings),
        titleSize,
    };
    if ((!title || title === '') && !arrowsToTopRight) {
        return null;
    }
    return (React.createElement("div", { className: cn(className, styles.headingContainer, !title && styles.onlyControls, isTitleCenterAligned && styles.centreAlignTitle) },
        title && React.createElement(HeadingSelector, Object.assign({}, headingProps), title),
        arrowsToTopRight && (React.createElement("div", null,
            React.createElement(CarouselText, { disabled: disablePrevArrow, onClick: () => carouselRef.current.slickPrev(), label: labels.prev, direction: "prev" }),
            React.createElement(CarouselText, { disabled: disableNextArrow, onClick: () => carouselRef.current.slickNext(), label: labels.next, direction: "next" })))));
};
export default CarouselHeading;
//# sourceMappingURL=CarouselHeading.js.map